import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";

import Brands from "./Brands.graphql";

export default function useBrands() {
    return useQuery(gql(Brands));
}
